import { Injectable } from '@angular/core';
import * as pubsub from "pubsub-js";

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private loading = false;
  private message = '';

  constructor() {
  }

  show() {
    pubsub.publish("PROGRESS_SPINNER", true)
  }

  hide() {
    pubsub.publish("PROGRESS_SPINNER", false)

  }

  public get isLoading() {
    return this.loading;
  }

  public get getMessage(){
    return this.message;
  }
}
